import type { ResumenEvaluacionResponse } from '@/types/types';
import { api } from './api';

export const resumenService = {
  async getResumen(nit: string, asesoriaId?: number): Promise<ResumenEvaluacionResponse> {
    const query = asesoriaId ? `?asesoriaId=${asesoriaId}` : '';
    return api.get<ResumenEvaluacionResponse>(`/empresas/${nit}/asesoria-activa/resumen${query}`);
  },
};
